/* eslint-disable */
import Vue from 'vue'
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import algoFirst from '../../components/algo-task-first/index.vue';
import algoTwo from '../../components/algo-task-two/index.vue';
import algoThird from '../../components/algo-task-third/index.vue';
import algoFour from '../../components/algo-task-four/index.vue';
export default {
  name: 'task-new-page',
  components: {
    'algo-first':algoFirst,
    'algo-two':algoTwo,
    'algo-third':algoThird,
    'algo-four':algoFour
  },
  props: [],
  data () {
    return{

    }
  },
  computed: {
  },
  beforeMount(){
  },
  mounted () {
    setTimeout(function() {
      $('input').attr('autocomplete', 'off');
  }, 100);
  $(document).ready(function(){
    $(".task_accordion_header, .task_accordion_header_inner").click(function(event){
      if($(this).parents('.task_accordion_wrp').hasClass('actv_accordion')){
        // $(this).parents('.task_accordion_wrp').removeClass('actv_accordion')
        // $(this).parent().find(".task_accordion_desc2").slideUp(350);
      }else{
        $(".task_accordion_desc2").slideUp(350);
        $(this).parent().find(".task_accordion_desc2").slideDown(350);
        $('.task_accordion_wrp').removeClass('actv_accordion')
        $(this).parents('.task_accordion_wrp').addClass('actv_accordion')
        $(window).scrollTop(0);
      }
    })
    $(".task_accordion_header .task_accordion_arrow .fa").click(function(event){
      setTimeout(() => {
        $('.task_accordion_wrp').removeClass('actv_accordion')
      $(".task_accordion_desc2").slideUp(350);
      }, 100);
      // if($(this).parents('.task_accordion_wrp').hasClass('actv_accordion')){
      //   $(this).parents('.task_accordion_wrp').removeClass('actv_accordion')
      //   $(this).parent().find(".task_accordion_desc2").slideUp(350);
      // }else{
      //   $(".task_accordion_desc2").slideUp(350);
      //   $(this).parent().find(".task_accordion_desc2").slideDown(350);
      //   $('.task_accordion_wrp').removeClass('actv_accordion')
      //   $(this).parents('.task_accordion_wrp').addClass('actv_accordion')
      //   $(window).scrollTop(0);
      // }
    })
    $(".edit_list_wrp .fa-pencil").click(function(){
      $(".task_accordion_desc").slideUp("fast");
    })
    $('.task_accordion_header .form-heading').mouseenter(function(){
      if (jQuery(this).hasClass('opencat')) {
        $(this).parent().find(".task_accordion_desc").slideUp(350);
        setTimeout(() => {
          jQuery(this).removeClass('opencat');
        }, 350);
     } else {
       jQuery('.task_accordion_desc').slideUp(350);
       jQuery('.task_accordion_header').removeClass('opencat')
       $(this).parent().find(".task_accordion_desc").slideDown(350);
       setTimeout(() => {
        jQuery(this).removeClass('opencat');
      }, 350);
     }
    }).mouseleave(function(){
      $(this).parent().find(".task_accordion_desc").slideUp(350);
      setTimeout(() => {
        jQuery(this).removeClass('opencat');
      }, 350);
   });


  })
  },
  methods: {
  },
  beforeCreate: function() {
    $('body').addClass('sidebar_collapsed')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('sidebar_collapsed')
    next();
  },
}